import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { CommunicationMedium, CommunicationSetting } from "models";

export interface CommunicationMediumVariation extends CommunicationMedium {
  parent_id: number;
}

export interface GroupedCommunicationMedium extends CommunicationMedium {
  variations?: CommunicationMediumVariation[];
}

const component = "CommunicationTemplates";

export const CommunicationTemplatesQueryKeys = {
  getCommunicationMediums: backendQueryKey<GroupedCommunicationMedium[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/communication/mediums/list" }),
  getCommunicationSettings: backendQueryKey<CommunicationSetting>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/communication/settings/read" }),
  getDefaultTemplates: backendQueryKey<CommunicationMedium[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/communication/mediums/list_defaults" })
};
